export default __webpack_public_path__ + "static/media/shrava v6.357d375b.mp4";